module.exports = __webpack_public_path__ + "static/Abacus Dossier aus Sicht HR-bfc85a554bed074015788f288fba30c0.png";